export default [
    {
        path: '/ged-config',
        name: 'ged-config',
        component: () => import('./views/GedConfig.vue'),
        meta: {
            title: 'Configuração GED',
            icon: 'mdi-cloud-upload',
            breadcrumbs: [
                { text: 'Integrações', disabled: true },
                { text: 'Configuração GED', disabled: true }
            ]
        }
    },
]
